import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizExternalProps,
} from '../../types';
import { timePeriodSegmentedTableViewDataToUiComponentProps } from './dataToUiComponentProps';
import {
  TimePeriodSegmentedTableViewActions,
  TimePeriodSegmentedTableViewState,
  TimePeriodSegmentedTableViewUiComponentProps,
} from './types';
import { TimePeriodSegmentedBarChartUiComponent } from './UiComponent';
import { useTimePeriodSegmentedBarChartStateManager } from './useStateManager';

export const timePeriodSegmentedTableViewViewConfig: DataVizContainerViewConfigWithStateManager<
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizExternalProps,
  TimePeriodSegmentedTableViewUiComponentProps,
  TimePeriodSegmentedTableViewState,
  TimePeriodSegmentedTableViewActions
> = {
  hasStateManager: true,
  useStateManager: useTimePeriodSegmentedBarChartStateManager,
  dataToUiComponentProps: timePeriodSegmentedTableViewDataToUiComponentProps,
  UiComponent: TimePeriodSegmentedBarChartUiComponent,
};
